import { Typography } from "@mui/material";
import { useTheme } from "../../../../../../../../../context/themeContext";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setIsPageLoading } from "../../../../../../../../../store/slices/loadingSlice";

const NotLogedIn = () => {
  const { theme, darkMode } = useTheme();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.value);
  const { loginWithRedirect } = useAuth0();

  const navigate = useNavigate();

  if (user) {
    return <></>;
  }

  return (
    <Typography
      variant="body1"
      sx={{
        color: darkMode
          ? theme.palette.darkgrey.darkgreybody50
          : theme.palette.darkgrey.darkgrey400,
        fontSize: "16px",
        fontWeight: "500",
      }}
    >
      <span
        onClick={async () => {
          dispatch(setIsPageLoading(true));
          await loginWithRedirect({ connection: "google-oauth2" });
          dispatch(setIsPageLoading(false));
        }}
        style={{
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        Login{" "}
      </span>
      or
      <span
        onClick={() => {
          navigate("/signup");
        }}
        style={{
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        {" "}
        create account{" "}
      </span>{" "}
      to view
    </Typography>
  );
};

export default NotLogedIn;
